import React from "react";
import classes from "./BigHeader.module.scss";

interface Props extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  className?: string;
}

function BigHeader(props: Props) {
  return (
    <span className={`${props.className ?? props.className} ${classes.header_1}`}>
      {props.children}
    </span>
  );
}

export default BigHeader;
